<template>
    <div class="container-fluid">
        <div class="row justify-content-center align-items-center" style="height:100vh;">
            <div class="col-md-4 col-sm-6 col-xs-8">
                <div class="card">
                    <div class="card-header">Login</div>
                    <div class="card-body">
                        <form @submit.prevent="handleSubmit">
                            <div class="form-group mb-3">
                                <label for="username">Username:</label>
                                <input type="text" id="username" v-model="username" class="form-control" required>
                            </div>
                            <div class="form-group mb-3">
                                <label for="password">Password:</label>
                                <input type="password" id="password" v-model="password" class="form-control" required>
                            </div>
                            <button type="submit" class="btn btn-primary">Login</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState({
            access_token: state => state.access_token,
        })
    },
    data() {
        return {
            username: '',
            password: '',
        }
    },
    created() {
        if (this.access_token !== null) {
            location.href = '/'
        }
    },
    methods: {
        handleSubmit() {
            const uri = '/api/login'

            this.axios.post(uri, {username: this.username, password: this.password}).then(response => {
                if (response.data.status == 'success') {
                    const payload = {
                        auth_status: true,
                        access_token: response.data.token,
                        user: response.data.user
                    }
                    this.$store.commit('setAuth', payload)
                    location.href = '/'
                } else {
                    this.$swal.fire({
                        title: 'Error!',
                        text: 'Username atau Password salah',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
            })
        }
    }
}
</script>